import React from 'react';

const Chat = ({styleProp}) => {

    return <div> tahC </div>
}

export default Chat